import React from "react";
import { useEffect, useState } from 'react';

export default function WaitCursor(props) {
    const [wait, setwait] = useState(false);

    useEffect(() => {
         setwait(props.active);
    }, [props.active]);

    return wait ? <div className="loading-overlay" /> : null;

}